import * as React from 'react';
import { DraftChatContext, type DraftChatContextValue } from './useDraftChatContext';

/** Provider wrapper for the draft test-chat; supplies draftId to descendants. */
export const DraftChatProvider: React.FC<{ draftId: string; children: React.ReactNode }> = ({
  draftId,
  children,
}) => {
  const value = React.useMemo<DraftChatContextValue>(() => ({ draftId }), [draftId]);
  return <DraftChatContext.Provider value={value}>{children}</DraftChatContext.Provider>;
};
